import { useEffect, useRef } from 'react';
import type { NavigateFunction } from 'react-router-dom';

/**
 * Deep-link pilot routes (/render/:slug) pin the URL slug until the operator switches
 * company in the header — then return to the canonical route so company.kryspace_slug drives reload.
 */
export function useCanonicalRouteOnCompanySwitch(
  slugFromRoute: boolean,
  selectedCompanyId: string | undefined,
  canonicalPath: string,
  navigate: NavigateFunction
): void {
  const previousCompanyIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!slugFromRoute) {
      previousCompanyIdRef.current = selectedCompanyId;
      return;
    }

    const previous = previousCompanyIdRef.current;
    previousCompanyIdRef.current = selectedCompanyId;

    if (
      previous !== undefined &&
      selectedCompanyId !== undefined &&
      previous !== selectedCompanyId
    ) {
      navigate(canonicalPath, { replace: true });
    }
  }, [slugFromRoute, selectedCompanyId, canonicalPath, navigate]);
}
